
export const createCalComUrl = ({reqId, compCtcName, compEmail, compPhone}) => {
    console.log('invoked', reqId)
        if (reqId) {
            const companyctcname = encodeURIComponent(compCtcName);
            const email = encodeURIComponent(compEmail);
            let companyPhone = compPhone.trim();

            if (!companyPhone.startsWith("+")) {
                if (companyPhone.startsWith("36")) {
                    companyPhone = `+${companyPhone}`;
                } else {
                    companyPhone = `+36${companyPhone}`;
                }
            }

            const location = encodeURIComponent(
                `{"value":"phone","optionValue":"${companyPhone}"}`
            );

            const metadata = encodeURIComponent(
                JSON.stringify({
                    reqId,
                    name: companyctcname,
                    email,
                    phone: companyPhone,
                })
            );

            const fullCalComURL = `https://cal.com/bookkeepie-ireland/bookkeepie-administration-appointment-booking?reqID=${reqId}&name=${companyctcname}&email=${email}&location=${location}&metadata=${metadata}`;
            console.log('fullcalcomurl', fullCalComURL)
            return fullCalComURL;
        }
}

export const navigateToUrl = (url) => {
    window.location.href = url;
}